var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KpiPopUp',{ref:"kpiPopUp"}),_c('CibPopUp',{ref:"cibPopUp"}),_c('CompanyPopUp',{ref:"CompanyPopUp"}),_c('ManagerPopUp',{ref:"ManagerPopUp"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }